import { render, staticRenderFns } from "./set_up_stations.vue?vue&type=template&id=c4957c48"
import script from "./set_up_stations.vue?vue&type=script&lang=js"
export * from "./set_up_stations.vue?vue&type=script&lang=js"
import style0 from "./set_up_stations.vue?vue&type=style&index=0&id=c4957c48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports